import { useEffect, useState } from "react";

const LOGS = {
  "01": "> sessione aperta · operatore: presente",
  "02": "> sezione_02 caricata · latenza 0,9s",
  "03": "> sezione_03 caricata · Δ 10^6",
  "04": "> sezione_04 caricata · facoltà rilevate: 3",
  "05": "> sezione_05 caricata · fonte: prefazione",
  W: "> finestra_30s · in attesa dell'operatore",
  "06": "> sezione_06 sbloccata · scelta: umana",
};
const ORDER = ["01", "02", "03", "04", "05", "W", "06"];

export const LogRail = () => {
  const [cur, setCur] = useState("01");

  useEffect(() => {
    const io = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && setCur(e.target.dataset.rail)),
      { rootMargin: "-45% 0px -50% 0px" }
    );
    const observe = () => document.querySelectorAll("[data-rail]").forEach((el) => io.observe(el));
    observe();
    const mo = new MutationObserver(observe);
    mo.observe(document.querySelector("main"), { childList: true });
    return () => { io.disconnect(); mo.disconnect(); };
  }, []);

  return (
    <aside className="log-rail mono" aria-hidden="true" data-testid="log-rail">
      <ol className="rail-ladder">
        {ORDER.map((k) => (
          <li key={k} className={k === cur ? "on" : ""}>{k === "W" ? "30s" : k}</li>
        ))}
      </ol>
      <p key={cur} className="rail-log" data-testid="log-rail-current">{LOGS[cur]}</p>
      <span className="rail-tick" />
    </aside>
  );
};
